import baseAPI from "@/api/base";
import { GetPhoneNumber, RegisterPhoneNumber } from "@/dtos/PhoneNumber.dto";
import {
  DELETE_PHONE_NUMBER_URL,
  EDIT_CONTACT_PHONE_NUMBER_URL,
  GET_PHONE_NUMBER_ROTATIONS_URL,
  GET_PHONE_NUMBER_URL,
  REGISTER_PHONE_NUMBER_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class PhoneNumber {
  static getPhoneNumbers = async (
    getPhoneNumber: GetPhoneNumber,
    retryCount = 0,
    maxRetries = 2
  ): Promise<AxiosResponse> => {
    try {
      const response: AxiosResponse = await baseAPI.get(GET_PHONE_NUMBER_URL, {
        params: getPhoneNumber,
        timeout: 15000,
      });
      return response;
    } catch (error: any) {
      console.error("Phone number request failed:", error);

      if (
        (error.code === "ECONNABORTED" || error.message?.includes("timeout")) &&
        retryCount < maxRetries
      ) {
        const delay = Math.pow(2, retryCount) * 1000;
        await new Promise((resolve) => setTimeout(resolve, delay));
        return this.getPhoneNumbers(getPhoneNumber, retryCount + 1, maxRetries);
      }

      throw error;
    }
  };

  static getRotatedPhoneNumbers = async (
    getPhoneNumber: GetPhoneNumber
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PHONE_NUMBER_ROTATIONS_URL, {
      params: getPhoneNumber,
    });
    return response;
  };

  static registerPhoneNumber = async (
    registerPhoneNumber: RegisterPhoneNumber
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_PHONE_NUMBER_URL, {
      ...registerPhoneNumber,
    });
    return response;
  };

  static deletePhoneNumber = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_PHONE_NUMBER_URL}/${id}`);
    return response;
  };

  static putEditContactPhoneNumber = async (body: {
    contactId: string;
    oldPhoneNumber: string;
    phoneNumber: string;
    phoneNumberType?: "MOBILE" | "DIRECT" | "WORK" | "HOME" | "OTHER";
    routeType?: "DIRECT" | "MOBILE" | "IVR" | "GATEKEEPER";
    ivrExtension?: string;
    gatekeeperName?: string;
    isValid?: boolean | null;
  }): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_CONTACT_PHONE_NUMBER_URL, body);
    return response;
  };
}

export default PhoneNumber;
